import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { TOAST_CONTAINER_DIV_CONTENT, TOAST_CONTAINER_DIV_PORTAL, TOAST_DEFAULT_DURATION_IN_MILLISECONDS, TOAST_DEFAULT_POSITION } from './Toast.constants';
import { render } from 'react-dom';
import { ToastItem } from './ToastItem';
import UIProvider from '../../common/UIProvider/UIProvider';
// Hooks.
// -----------------------------------------------------------------------------
export const useToast = ({ duration = TOAST_DEFAULT_DURATION_IN_MILLISECONDS, maxWidth, position = TOAST_DEFAULT_POSITION } = {
    duration: TOAST_DEFAULT_DURATION_IN_MILLISECONDS,
    position: TOAST_DEFAULT_POSITION
}) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [node, setNode] = useState(null);
    const [toasts, setToasts] = useState([]);
    // Functions.
    // ---------------------------------------------------------------------------
    const removeToast = useCallback((key) => {
        setToasts((prev) => prev.filter((toast) => toast.key !== key));
    }, []);
    const showToast = useCallback(({ message, title, type }) => {
        setToasts((prev) => [
            ...prev,
            {
                key: prev.length === 0 ? 0 : prev[prev.length - 1].key + 1,
                message,
                title,
                type
            }
        ]);
    }, []);
    const showSuccess = useCallback((message, title) => {
        showToast({ message, title, type: 'success' });
    }, [showToast]);
    const showError = useCallback((message, title) => {
        showToast({ message, title, type: 'error' });
    }, [showToast]);
    const showWarning = useCallback((message, title) => {
        showToast({ message, title, type: 'warning' });
    }, [showToast]);
    const showInfo = useCallback((message, title) => {
        showToast({ message, title, type: 'info' });
    }, [showToast]);
    // Effect.
    // ---------------------------------------------------------------------------
    useEffect(() => {
        if (!node) {
            const div = document.createElement('div');
            div.id = TOAST_CONTAINER_DIV_PORTAL;
            document.body.appendChild(div);
            setNode(div);
        }
        return () => {
            if (node && node.parentNode === document.body) {
                document.body.removeChild(node);
            }
        };
    }, [node]);
    useEffect(() => {
        const container = document.getElementById(TOAST_CONTAINER_DIV_CONTENT);
        if (container) {
            render(_jsx(_Fragment, { children: toasts.map(({ key, message, title, type }) => (_jsx(UIProvider, { children: _jsx(ToastItem, { id: key, duration: duration, maxWidth: maxWidth, message: message, position: position, onRemove: removeToast, title: title, type: type }) }, `toast-item-${key}`))) }), container);
        }
    }, [duration, maxWidth, position, removeToast, toasts]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        node,
        showError,
        showInfo,
        showSuccess,
        showWarning
    };
};
//# sourceMappingURL=Toast.hooks.js.map